import wrapWithProvider from "./wrap-with-provider"
import "@fortawesome/fontawesome-svg-core/styles.css"
import { config } from "@fortawesome/fontawesome-svg-core";

config.autoAddCss = false;

// trigger an immediate page refresh when an update is found
export const onServiceWorkerUpdateReady = () => window.location.reload();
export const wrapRootElement = wrapWithProvider